var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Message } from "semantic-ui-react";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
export function ErrorMessage({ error, header, onRetry, children }) {
    if (!error) {
        return null;
    }
    const message = error instanceof Error ? error.message : typeof error === "string" ? error : "An unexpected error occurred.";
    return (_jsx(Message, { visible: true, error: true, header: header, content: _jsxs("div", { children: [_jsx("p", { "data-testid": "api-error-message", children: message }), _jsx("div", { children: children }), onRetry && (_jsx(AsyncButton, { type: "button", onClick: () => __awaiter(this, void 0, void 0, function* () { return onRetry(); }), children: "Try again" }))] }) }));
}
